import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import StaffManagement from "components/staff-management";
import { Tables } from "components/layout";
import { STAFF_ATTENDANCE_PAGE_SIZE } from "components/staff-management/helpers/staff-attendance-api-helper";


const StaffManagementAttendanceSubPage = ({ event }) => {
    const history = useHistory();
    const { pathname } = useLocation();
    const routeUrl = `${ StaffManagement.Const.basePath }/${ event.id }/attendance`;
    const match = useRouteMatch(`${ routeUrl }/page/:pageNum`);
    const parsedPage = match ? Number(match.params.pageNum) : 1;
    const requestedPage = Number.isInteger(parsedPage) && parsedPage > 0 ? parsedPage : 1;
    const [ searchText, setSearchText ] = useState("");
    const [ period, setPeriod ] = useState([]);
    const [ subcontractorID, setSubcontractorID ] = useState();
    const [ groupBy, setGroupBy ] = useState(StaffManagement.Const.attendanceGroupBy.DATE);
    const [ scanLocation, setScanLocation ] = useState();

    const resetPage = useCallback(() => {
        if (requestedPage !== 1)
        {
            history.push(routeUrl);
        }
    }, [ history, requestedPage, routeUrl ]);

    const {
        data: groups,
        loading,
        paginatorInfo,
        query,
    } = StaffManagement.Hooks.useStaffAttendance({
        eeID: event.id,
        groupBy,
        searchText,
        period,
        subcontractorID,
        page: requestedPage,
        perPage: STAFF_ATTENDANCE_PAGE_SIZE,
    });

    const tableHelper = useMemo(() => (
        StaffManagement.Helpers.AttendanceTable(groupBy, setScanLocation)
    ), [ groupBy ]);
    const tableModel = useMemo(() => ({
        data: groups,
        paginatorInfo,
    }), [ groups, paginatorInfo ]);

    useEffect(() => {
        if (!loading)
        {
            const canonicalPath = paginatorInfo.currentPage === 1 ?
                routeUrl :
                `${ routeUrl }/page/${ paginatorInfo.currentPage }`;

            if (pathname !== canonicalPath)
            {
                history.replace(canonicalPath);
            }
        }
    }, [ history, loading, paginatorInfo.currentPage, pathname, routeUrl ]);

    return (
        <>
            <div className="staff-management-view-shell--attendance">
                <Tables.Main
                    querySkip={ true }
                    model="staffAttendance"
                    query={ query }
                    routeUrl={ routeUrl }
                    currentPage={ paginatorInfo.currentPage }
                    searchText={ searchText }
                    objFilter={ {} }
                    varSet={ { perPage: STAFF_ATTENDANCE_PAGE_SIZE } }
                    tableHelper={ tableHelper }
                    externalModel={ tableModel }
                    externalLoading={ loading }
                    extraClass="staff-attendance-table"
                    scroll={ { x: 1321 } }>
                    <StaffManagement.Filters.AttendanceTable
                        searchText={ searchText }
                        setSearchText={ setSearchText }
                        period={ period }
                        setPeriod={ setPeriod }
                        subcontractorID={ subcontractorID }
                        setSubcontractorID={ setSubcontractorID }
                        groupBy={ groupBy }
                        setGroupBy={ setGroupBy }
                        resetPage={ resetPage } />
                </Tables.Main>
            </div>

            <StaffManagement.Fields.ScanLocationModal
                event={ event }
                open={ Boolean(scanLocation) }
                location={ scanLocation }
                onClose={ () => setScanLocation(undefined) } />
        </>
    );
};

export default StaffManagementAttendanceSubPage;
